import { useReducer } from 'react'

const toggleReducer = (state: boolean, nextValue?: boolean) => (nextValue !== undefined ? nextValue : !state)

export const useToggle = (initialValue = false): [boolean, (value?: boolean) => void] =>
  useReducer(toggleReducer, initialValue)
